import { createNamespacer, createReducer } from "../utils/reducers";

const initialState = {
  isLoading: false,
  appDataLoading: false,
  showAdvanceSearch: false,
  isAdminSidebarOpen: false,
};

const namespacer = createNamespacer("APPEARANCE");

const handlers = {
  [`${namespacer("SET_LOADING")}`]: (state: any, action: any) => {
    return {
      ...state,
      isLoading: action.payload?.value,
    };
  },
  [`${namespacer("SET_APP_DATA_LOADING")}`]: (state: any, action: any) => {
    return {
      ...state,
      appDataLoading: action.payload.value,
    };
  },
  [`${namespacer("SHOW_ADVANCED_SEARCH")}`]: (state: any) => {
    return {
      ...state,
      showAdvanceSearch: !state.showAdvanceSearch,
    };
  },
  [`${namespacer("TOGGLE_ADMIN_SIDEBAR")}`]: (state: any) => {
    return {
      ...state,
      isAdminSidebarOpen: !state.isAdminSidebarOpen,
    };
  },
  [`${namespacer("SET_ADMIN_SIDEBAR")}`]: (state: any, action: any) => {
    return {
      ...state,
      isAdminSidebarOpen: action.payload.value,
    };
  },
};

const appearanceReducer = createReducer(initialState, handlers, ["APPEARANCE"]);

export default appearanceReducer;
